import { Directive } from '@angular/core';

@Directive({
  selector: '[showFooter]'
})
export class ShowFooterDirective {
  constructor() {}
}
